import React, { useRef, useState } from "react";

function isPdfFile(file) {
  if (!file) return false;
  return file.type === "application/pdf" || /\.pdf$/i.test(file.name || "");
}

export default function PdfDropZone({
  label = "Book Preview PDF",
  selectedFile,
  onFileSelect,
  currentFileUrl = "",
  helperText = "Drag and drop a PDF here, or click to browse.",
}) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileSelection = (fileList) => {
    const nextFile = fileList?.[0];
    if (!nextFile) return;

    if (!isPdfFile(nextFile)) {
      alert("Please upload a PDF file for the book preview.");
      return;
    }

    onFileSelect(nextFile);
  };

  return (
    <div>
      <label style={{ display: "block", fontSize: "0.9rem", fontWeight: "600", marginBottom: "10px", color: "var(--text2)" }}>
        {label}
      </label>

      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,.pdf"
        onChange={(e) => handleFileSelection(e.target.files)}
        style={{ display: "none" }}
      />

      <div
        role="button"
        tabIndex={0}
        onClick={() => inputRef.current?.click()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            inputRef.current?.click();
          }
        }}
        onDragEnter={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setIsDragging(false);
        }}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);
          handleFileSelection(e.dataTransfer.files);
        }}
        style={{
          border: `2px dashed ${isDragging ? "var(--forest)" : "var(--border)"}`,
          borderRadius: "14px",
          padding: "24px",
          background: isDragging ? "rgba(46, 125, 50, 0.06)" : "white",
          cursor: "pointer",
          transition: "border-color 0.2s ease, background 0.2s ease",
        }}
      >
        <div style={{ fontSize: "2rem", marginBottom: "10px" }}>PDF</div>
        <div style={{ fontWeight: "700", color: "var(--text)", marginBottom: "6px" }}>
          {selectedFile ? selectedFile.name : "Drop preview PDF here"}
        </div>
        <div style={{ color: "var(--text2)", fontSize: "0.92rem", lineHeight: 1.6 }}>
          {selectedFile ? "Click or drop another PDF to replace the selected preview." : helperText}
        </div>

        {currentFileUrl && !selectedFile && (
          <button
            type="button"
            className="btn btn-ghost"
            onClick={(e) => {
              e.stopPropagation();
              window.open(currentFileUrl, "_blank", "noopener,noreferrer");
            }}
            style={{ marginTop: "14px" }}
          >
            Open Current PDF
          </button>
        )}
      </div>
    </div>
  );
}
